export const helpLinks = {
  finances: [
    {
      name: 'Présentation générale',
      url: 'https://youtu.be/H-SNAV5b-1s'
    },
    {
      name: 'Lecture de vos finances',
      url: 'https://youtu.be/wpNWZ-tpoXk'
    }
  ],
  commandes: [
    {
      name: 'Présentation générale',
      url: 'https://youtu.be/Cx0sZVKafIY'
    }
  ],
  stocks: [
    {
      name: 'Présentation générale',
      url: 'https://youtu.be/Cx0sZVKafIY'
    }
  ],
  livreurs: [
    {
      name: 'Présentation générale',
      url: 'https://youtu.be/bLzSZbxC4JQ'
    }
  ],
  clients: [
    {
      name: 'Présentation générale',
      url: 'https://youtu.be/TQzZ8eXLkbo'
    }
  ],
  factures: [
    {
      name: 'Présentation générale',
      url: 'https://youtu.be/lyH8_cX4YpI'
    }
  ],
  design: [
    {
      name: 'Présentation générale',
      url: 'https://youtu.be/J7rN8HYJcWc'
    }
  ],
  produits: [
    {
      name: "Création d'une section",
      url: 'https://youtu.be/aNkNEdCo5m0'
    },
    {
      name: "Création d'un produit",
      url: 'https://youtu.be/IwJoSomdao8'
    }
  ],
  options: [
    {
      name: 'Présentation générale',
      url: 'https://youtu.be/ObYgW6FWsZA'
    }
  ],
  codepromo: [
    {
      name: 'Présentation générale',
      url: 'https://youtu.be/3v0Se4VpHHs'
    }
  ],
  pushnotif: [
    {
      name: 'Présentation générale',
      url: 'https://youtu.be/hzP7ND_PEBM'
    }
  ],
  reglages: [
    {
      name: 'Réglages de base',
      url: 'https://youtu.be/iir2LL8TUXE'
    },
    {
      name: 'Zones de livraison',
      url: 'https://youtu.be/qKGDDNDavd8'
    },
    {
      name: 'Horaires spécifiques',
      url: 'https://youtu.be/bMwfTI5uubo'
    }
  ]
};
